import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { FaRegBell } from 'react-icons/fa';
import SkeletonSidebarSection from 'components/bigBookingWidgetDrawer/SkeletonSidebarSection';
import BestRateSection from 'components/bigBookingWidgetDrawer/BestRateSection';
import { RatingsSection } from 'components/bigBookingWidgetDrawer/RatingsSection';
import { WhyBookDirectlySection } from 'components/bigBookingWidgetDrawer/WhyBookDirectlySection';
import { Switch } from 'components/common/switch';
import { VscInfo } from 'react-icons/vsc';
import { Button } from 'components/common/button';
import { Skeleton } from 'components/common/skeleton';
import { setSelectedCancellationAndPaymentPolicyData } from 'features/userSlice';
import { closeModal, openModal } from 'features/modalSlice';
import './SinglePropertySidebar.css';

const SinglePropertySidebar = ({ propertyType, mainClass = '' }) => {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.miniBookingWidget?.data);
    const Lang = data?.Lang;
    const isFetchingPrices = useSelector(
        (state) => state.miniBookingWidget.isFetching
    );

    const { isTrackPricesModalOpen } = useSelector((state) => state.modal);
    const showScoresComments = data?.showScoresComments;
    const handleInfoIconClick = useCallback((data) => {
        dispatch(setSelectedCancellationAndPaymentPolicyData({ ...data }));
        dispatch(
            openModal({
                modalId: 'CancellationAndPaymentPolicyModal',
            })
        );
    }, []);
    const openTrackPricesModal = useCallback(() => {
        if (!isTrackPricesModalOpen) {
            dispatch(
                openModal({
                    modalId: 'TrackPricesModal',
                })
            );
        } else {
            dispatch(
                closeModal({
                    modalId: 'TrackPricesModal',
                })
            );
        }
    }, [dispatch, isTrackPricesModalOpen]);

    return (
        <div className={`ab-body-sidebar ${mainClass}`}>
            <div className="ab-body-sidebar-inner">
                <div className="ab-body-sidebar-alert">
                    {isFetchingPrices && (
                        <Skeleton width={'100%'} height={70} />
                    )}

                    {!isFetchingPrices && (
                        <>
                            <div className="ab-section-alertheader">
                                <span height="17" cleanup="" className="svg">
                                    <FaRegBell size={14} />
                                </span>
                                {data?.bigPlugin?.priceAlertText}
                            </div>
                            <div className="ab-section-body">
                                <div>
                                    <div className="ab-textAndTooltip">
                                        <span>
                                            {data?.bigPlugin?.checkPriceText}
                                        </span>

                                        <Button
                                            className="ab-btn-info--room-details svg"
                                            onClick={() =>
                                                handleInfoIconClick({
                                                    modalTitle:
                                                        Lang?.trackPrices,
                                                    modalContent:
                                                        Lang?.priceAlertsText,
                                                })
                                            }
                                            icon={
                                                <VscInfo
                                                    style={{
                                                        lineHeight: 'inherit',
                                                        color: 'inherit',
                                                        marginTop: '0px',
                                                    }}
                                                    size={17}
                                                />
                                            }
                                        />
                                    </div>

                                    <Switch
                                        checked={isTrackPricesModalOpen}
                                        onChange={openTrackPricesModal}
                                        id="ab-track-prices-switch"
                                    />
                                </div>
                            </div>
                        </>
                    )}
                </div>
                {isFetchingPrices && (
                    <>
                        <SkeletonSidebarSection variant="best-rate" />
                        <SkeletonSidebarSection />
                        <SkeletonSidebarSection />
                    </>
                )}

                {!isFetchingPrices && (
                    <>
                        <BestRateSection />
                        {showScoresComments && (
                            <RatingsSection
                                title={data?.bigPlugin?.ratingText}
                            />
                        )}

                        <WhyBookDirectlySection
                            title={data?.bigPlugin?.whyBookDireclty}
                            benefits={data?.bigPlugin?.directAppeal || []}
                        />
                    </>
                )}
            </div>
        </div>
    );
};

SinglePropertySidebar.propTypes = {
    propertyType: PropTypes.string,
    mainClass: PropTypes.string,
};

export default SinglePropertySidebar;
